import { ApiMethodDeclaration } from '..';

type ParamsData = {
    adminEmail?: string;
    entityType?: 'attraction' | 'person' | 'route' | 'quest';
    limit?: number;
};

type ReviewItem = {
    id: number;
    adminEmail: string;
    entityType: 'attraction' | 'person' | 'route' | 'quest';
    entityId: number;
    entityTitle: string;
    locale: string | null;
    fieldKey: string;
    oldValue: string | null;
    newValue: string | null;
    status: 'new' | 'ok' | 'bad';
    createdAt: string | Date;
};

type ResponseData = {
    totalNew: number;
    items: ReviewItem[];
};

export const quiz: ApiMethodDeclaration<ParamsData, ResponseData> = (params) => ({
    url: '/admin/content-reviews/quiz',
    method: 'GET',
    params: {
        adminEmail: params?.adminEmail,
        entityType: params?.entityType,
        limit: params?.limit,
    },
});
